<div class="blotter_table_target" #tableTarget>
  <ag-grid-angular
    style="width: 100%; height: 100%"
    class="ag-bcdfx pinned-border"
    [frameworkComponents]="frameworkComponents"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
    [toolPanelSuppressSideButtons]="true"
    enableColResize
    multiSortKey="ctrl"
    (mouseup)="onMouseUp($event)"
    (contextmenu)="handleClick($event)"
    [ngClass]="{'intentStyled': isIntentStyled === true, 'fullTempStyled': isFullTempStyle === true}"
  >
  </ag-grid-angular>
</div>
<bmark-spot-risk-context-menu [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bmark-spot-risk-context-menu>
<bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bfx-blotter-column-selector>

<!-- Overlay panel for valuer date totals-->
<p-overlayPanel
  #valuedatetotals
  styleClass="order__details__overlay bm-allocation-overlay"
  appendTo="body"
  [showCloseIcon]="false"
  [dismissable]="true"
  [style]="{'width': '360px'}"
>
  <div style="display: flex; flex-direction: row; flex-wrap: wrap">
    <div class="order__details__body__value bm-risk-pair-overlay-title">{{valueDateTitle}}</div>
    <button
      type="button"
      (click)="valuedatetotals.hide()"
      class="bfx-button-secondary-subtle bfx-icon-sm icon-close order__details__contacts__close"
      placeholder="Close"
      title="Close"
    ></button>
  </div>
  <div class="divider"></div>
  <p-dataTable [value]="valueDateModels" scrollable="true">
    <p-column field="intent" header="Intent" [style]="{'width':'60px'}">
      <ng-template let-col let-data="rowData" pTemplate="body">
        <div
          class="center-text-overlay"
          [appendTo]="desktop ? 'target' : 'body'"
          title="{{data.intent}}"
        >
          {{data.intent}}
        </div>
      </ng-template>
    </p-column>
    <p-column field="amount" header="Amount" [style]="{'width':'100px'}">
      <ng-template let-col let-data="rowData" pTemplate="body">
        <div
          class="amount-overlay"
          [appendTo]="desktop ? 'target' : 'body'"
          title="{{data.amount}}"
        >
          {{data.amount}}
        </div>
      </ng-template>
    </p-column>
    <p-column field="valueDate" header="Value Date" [style]="{'width':'100px'}">
      <ng-template let-col let-data="rowData" pTemplate="body">
        <div
          class="ui-overlaypanel-cell"
          [appendTo]="desktop ? 'target' : 'body'"
          title="{{data.valueDate}}"
        >
          {{data.valueDate}}
        </div>
      </ng-template>
    </p-column>
  </p-dataTable>
</p-overlayPanel>
